import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  --card-stack-width: calc(100vw - 8rem);
  --card-stack-height: 85vh;
`
